import { Injectable } from '@angular/core';
import { GridService } from '../shared/grid/grid.service';
import { HttpClient } from '@angular/common/http';
import { ControlOrganizationLevelSeg } from '../models/controlOrganizationLevelSeg.model';

@Injectable({
  providedIn: 'root'
})
export class ControlOrganizationLevelSegService extends GridService<ControlOrganizationLevelSeg> {
  
  constructor(http: HttpClient) {
    super('ControlOrganizationLevelSeg', http);
  }
}
